<div *ngIf="isFirstMenuVisible" id="sidebar" [ngClass]="{ 'sidebar': !isCollapsed, 'sidebar-collapsed': isCollapsed }" class="flex flex-col">
    <div id="logo" class="p-4">
        <img
            [src]="isCollapsed ? '../../../../assets/img/solfium/new-logo-solfium-without_text.svg' : '../../../../assets/img/solfium/new-logo-solfium.svg'"
            class="h-8" alt="Logo"
        />
    </div>

    <div id="options" class="flex flex-col py-4 px-3 grow gap-3" [ngClass]="{ 'items-center': isCollapsed }">
        <div *ngIf="flag_client_selected" id="filter_clientSelected">
            <div class="flex items-center py-05 px-2">
                <span class="text-12px" [ngClass]="{ 'hidden': isCollapsed }">{{ clientSelected }}</span>
                <button mat-icon-button (click)="menuTrigger.openMenu(); updateMatMenuBackground()">
                    <mat-icon class="material-symbols-rounded text-16px">info</mat-icon>
                    <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></div>
                </button>
            </div>
            <mat-menu #menu="matMenu">
                <div class="flex flex-col gap-8">
                    <div>
                        <p class="text-14px font-semibold informationClient mb-1">Filtro de cliente aplicado</p>
                        <p class="text-14px informationClient mb-0">Los datos visibles pertenecen al cliente <span class="font-semibold">{{ clientSelected }}</span>.</p>
                    </div>
                    <div class="flex flex-row gap-2">
                        <button class="text-14px font-semibold btnResetFilter" (click)="clear_select()" mat-button>Resetear Filtro</button>
                        <button class="text-14px font-semibold btnChangeClient" (click)="change_client()" mat-button>Cambiar cliente</button>
                    </div>
                </div>
            </mat-menu>
        </div>
        <div class="flex items-center p-2 gap-8" id="dashboard_comercial" *ngIf="flag_dashboard_comercial"
            [ngClass]="{ 'selected': isActive('/dashboard-comercial') }"
            (click)="navigate('/dashboard-comercial')"
            matTooltip="Comercial"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">home</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Comercial
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="dashboard_operative" *ngIf="flag_dashboard_operative"
            [ngClass]="{ 'selected': isActive('/dashboard-operative') }"
            (click)="navigate('/dashboard-operative')"
            matTooltip="Operativo"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">build</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Operativo
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="dashboard_environment" *ngIf="flag_dashboard_environment"
            [ngClass]="{ 'selected': isActive('/dashboard-environment') }"
            (click)="navigate('/dashboard-environment')"
            matTooltip="CO2 y medio ambiente"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">nest_eco_leaf</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                CO2 y medio ambiente
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="dashboard_monitoring" *ngIf="flag_dashboard_monitoring"
            [ngClass]="{ 'selected': isActive('/dashboard-monitoring') }"
            (click)="navigate('/dashboard-monitoring')"
            matTooltip="Generación y monitoreo"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">monitoring</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Generación y monitoreo
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="dashboard_project_detail" *ngIf="flag_dashboard_project_detail"
            [ngClass]="{ 'selected': isActive('/dashboard-project-detail') }"
            (click)="navigate('/dashboard-project-detail')"
            matTooltip="Detalle de proyectos"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">featured_play_list</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Detalle de proyectos
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="dashboard_asset_map" *ngIf="flag_dashboard_asset_map"
            [ngClass]="{ 'selected': isActive('/dashboard-asset-map') }"
            (click)="navigate('/dashboard-asset-map')"
            matTooltip="Mapa de activos"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">location_on</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Mapa de activos
            </span>
        </div>

        <div class="flex items-center p-2 gap-8" id="dashboard_target_net_zero" *ngIf="flag_dashboard_target_net_zero"
            [ngClass]="{ 'selected': isActive('/dashboard-target-net-zero') }"
            (click)="navigate('/dashboard-target-net-zero')"
            matTooltip="Target Net zero"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">target</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Target NetZero
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" id="dashboard_download" *ngIf="flag_dashboard_download"
            [ngClass]="{ 'selected': isActive('/dashboard-download') }"
            (click)="navigate('/dashboard-download')"
            matTooltip="Descargas"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">download</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Descargas
            </span>
        </div>
    </div>

    <div id="actions" class="flex flex-col py-4 px-3 gap-3" [ngClass]="{ 'items-center': isCollapsed }">
        <div class="flex items-center p-2 gap-8"
            [ngClass]="{ 'selected': isActive('/dashboard-profile') }"
            (click)="navigate('/dashboard-profile')"
            matTooltip="Perfil"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">account_circle</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Perfil
            </span>
        </div>
        <div class="flex items-center p-2 gap-8" (click)="logout()"
            matTooltip="Cerrar sesión"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">logout</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Cerrar sesión
            </span>
        </div>
    </div>

    <div id="btn" class="flex justify-end py-2 px-3" [ngClass]="{ 'justify-center': isCollapsed }">
        <button class="btnCollapsed" (click)="toggleSidebar()">
            <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
    </div>
</div>

<div *ngIf="isSecondMenuVisible">
    <mat-drawer-container class="hidden-sidebar" autosize>
        <mat-drawer #drawer class="sidenav" mode="side">
            <div class="flex flex-col sidebar h-full">
                <div id="logo" class="p-4">
                    <img
                        [src]="isCollapsed ? '../../../../assets/img/solfium/new-logo-solfium-without_text.svg' : '../../../../assets/img/solfium/new-logo-solfium.svg'"
                        class="h-8" alt="Logo"
                    />
                </div>

                <div id="options" class="flex flex-col py-4 px-3 grow" [ngClass]="{ 'items-center': isCollapsed }">
                    <div class="flex items-center mb-3 p-2 gap-8" *ngIf="flag_client_selected">
                        <button mat-icon-button (click)="menuTrigger.openMenu(); updateMatMenuBackground()">
                            <mat-icon class="material-symbols-rounded text-16px">info</mat-icon>
                            <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></div>
                        </button>
                        <mat-menu #menu="matMenu">
                            <div class="flex flex-col gap-8">
                                <div>
                                    <p class="text-14px font-semibold informationClient mb-1">Filtro de cliente aplicado</p>
                                    <p class="text-14px informationClient mb-0">Los datos visibles pertenecen al cliente <span class="font-semibold">{{ clientSelected }}</span>.</p>
                                </div>
                                <div class="flex flex-row gap-2">
                                    <button class="text-14px font-semibold btnResetFilter" (click)="clear_select()" mat-button>Resetear Filtro</button>
                                    <button class="text-14px font-semibold btnChangeClient" mat-button>Cambiar cliente</button>
                                </div>
                            </div>
                        </mat-menu>
                    </div>
                    <div class="flex items-center mb-3 p-2 gap-8" *ngIf="flag_dashboard_comercial"
                        [ngClass]="{ 'selected': isActive('/dashboard-comercial') }"
                        (click)="navigate('/dashboard-comercial')">
                        <mat-icon class="material-symbols-rounded">home</mat-icon>
                        <span class="text-14px font-medium">
                            Comercial
                        </span>
                    </div>
                    <div class="flex items-center mb-3 p-2 gap-8" *ngIf="flag_dashboard_operative"
                        [ngClass]="{ 'selected': isActive('/dashboard-operative') }"
                        (click)="navigate('/dashboard-operative')">
                        <mat-icon class="material-symbols-rounded">build</mat-icon>
                        <span class="text-14px font-medium">
                            Operativo
                        </span>
                    </div>
                    <div class="flex items-center mb-3 p-2 gap-8" *ngIf="flag_dashboard_environment"
                        [ngClass]="{ 'selected': isActive('/dashboard-environment') }"
                        (click)="navigate('/dashboard-environment')">
                        <mat-icon class="material-symbols-rounded">nest_eco_leaf</mat-icon>
                        <span class="text-14px font-medium">
                            CO2 y medio ambiente
                        </span>
                    </div>
                    <div class="flex items-center mb-3 p-2 gap-8" *ngIf="flag_dashboard_monitoring"
                        [ngClass]="{ 'selected': isActive('/dashboard-monitoring') }"
                        (click)="navigate('/dashboard-monitoring')">
                        <mat-icon class="material-symbols-rounded">monitoring</mat-icon>
                        <span class="text-14px font-medium">
                            Generación y monitoreo
                        </span>
                    </div>
                    <div class="flex items-center mb-3 p-2 gap-8" *ngIf="flag_dashboard_project_detail"
                        [ngClass]="{ 'selected': isActive('/dashboard-project-detail') }"
                        (click)="navigate('/dashboard-project-detail')">
                        <mat-icon class="material-symbols-rounded">featured_play_list</mat-icon>
                        <span class="text-14px font-medium">
                            Detalle de proyectos
                        </span>
                    </div>
                    <div class="flex items-center p-2 gap-8" *ngIf="flag_dashboard_asset_map"
                        [ngClass]="{ 'selected': isActive('/dashboard-asset-map') }"
                        (click)="navigate('/dashboard-asset-map')">
                        <mat-icon class="material-symbols-rounded">location_on</mat-icon>
                        <span class="text-14px font-medium">
                            Mapa de activos
                        </span>
                    </div>

                    <div class="flex items-center p-2 gap-8" *ngIf="flag_dashboard_target_net_zero"
                        [ngClass]="{ 'selected': isActive('/dashboard-target-net-zero') }"
                        (click)="navigate('/dashboard-target-net-zero')">
                        <mat-icon class="material-symbols-rounded">target</mat-icon>
                        <span class="text-14px font-medium">
                            Target NetZero
                        </span>
                    </div>

                    <div class="flex items-center p-2 gap-8" *ngIf="flag_dashboard_download"
                        [ngClass]="{ 'selected': isActive('/dashboard-download') }"
                        (click)="navigate('/dashboard-download')">
                        <mat-icon class="material-symbols-rounded">download</mat-icon>
                        <span class="text-14px font-medium">
                            Descargas
                        </span>
                    </div>
                </div>

                <div id="actions" class="flex flex-col py-4 px-3" [ngClass]="{ 'items-center': isCollapsed }">
                    <div class="flex items-center mb-3 p-2 gap-8"
                        [ngClass]="{ 'selected': isActive('/dashboard-profile') }"
                        (click)="navigate('/dashboard-profile')">
                        <mat-icon class="material-symbols-rounded">account_circle</mat-icon>
                        <span class="text-14px font-medium">
                            Perfil
                        </span>
                    </div>
                    <div class="flex items-center mb-3 p-2 gap-8" (click)="logout()">
                        <mat-icon class="material-symbols-rounded">logout</mat-icon>
                        <span class="text-14px font-medium">
                            Cerrar sesión
                        </span>
                    </div>
                </div>
            </div>
        </mat-drawer>

        <div class="sidenav-content">
            <button type="button" mat-icon-button (click)="drawer.toggle()">
                <mat-icon>menu</mat-icon>
            </button>
        </div>
    </mat-drawer-container>
</div>
